import { apiClient } from './client';
import { API_ENDPOINTS } from '@/constants/api';
import type { CreateRSVPRequest, CreateRSVPResponse } from '@/types/api';

/**
 * API методы для работы с RSVP
 */
export const rsvpApi = {
  /**
   * Создает RSVP ответ для приглашения
   * @param inviteId - ID приглашения
   * @param data - Данные RSVP ответа
   * @returns Promise с результатом создания
   */
  create: async (
    inviteId: string,
    data: CreateRSVPRequest,
  ): Promise<CreateRSVPResponse> => (
    apiClient.post<CreateRSVPResponse>(API_ENDPOINTS.CREATE_RSVP(inviteId), data)
  ),
};
